import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [organizationBudgets, setOrganizationBudgets] = useState([]);
  const [costModel, setCostModel] = useState(null);
  const [resultTypes, setResultTypes] = useState([]);
  const [showColumns, setShowColumns] = useState({});
  const [emptySelectedCostCenters, setEmptySelectedCostCenters] = useState(false);
  const [initSelectedBudget, setInitSelectedBudget] = useState(null);
  const [organizationAccessIcons, setOrganizationAccessIcons] = useState([]);

  const location = useLocation();

  const lastPath = useMemo(() => {
    const pathParts = location.pathname.split('/');

    const orgId = pathParts[1] ? decodeURIComponent(pathParts[1]) : null;
    const budgetId = pathParts[2] || null;

    return { orgId, budgetId };
  },[location?.pathname]);

  const orgMatchesUrl = useMemo(() => {
    if (!user?.activeOrganization || !lastPath.orgId) return true;
    return user.activeOrganization === lastPath.orgId;
  }, [user?.activeOrganization, lastPath.orgId]);

  return (
    <UserContext.Provider value={{
      user,
      setUser,
      organizationBudgets,
      setOrganizationBudgets,
      costModel, setCostModel,
      resultTypes, setResultTypes,
      showColumns,
      setShowColumns,
      lastPath,
      orgMatchesUrl,
      emptySelectedCostCenters,
      setEmptySelectedCostCenters,
      initSelectedBudget, 
      setInitSelectedBudget,
      organizationAccessIcons, 
      setOrganizationAccessIcons,
    }}>
      {children}
    </UserContext.Provider>
  );
};

UserProvider.propTypes = {
  children: PropTypes.node,
};

export const useUser = () => {
  const context = useContext(UserContext);

  if (context === undefined || context === null) {
    throw new Error('useUser must be used within a UserProvider');
  }

  return context;
};
